import { render, staticRenderFns } from "./StokKartlar.vue?vue&type=template&id=cc33c22e&"
import script from "./StokKartlar.vue?vue&type=script&lang=js&"
export * from "./StokKartlar.vue?vue&type=script&lang=js&"
import style0 from "./StokKartlar.vue?vue&type=style&index=0&id=cc33c22e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports